<ResponseForm :close="close" :info="info"></ResponseForm>